import { FC } from 'react';
import {
  Button,
  ControlUnit,
  DailyBalanceChart,
  DailyTradeChart,
} from '@features/ui';
import { formatCurrency, formatDate } from '@lib/utils.ts';
import { PayoutRanking } from '@features/admin/payoutRequests/PayoutRanking.tsx';
import {
  BalanceStackedData,
  PaAccounts,
  StackedData,
  TPayout,
} from '@src/types';

interface AccountPABarActiveProps {
  onClose?: () => void;
  payoutSelected: TPayout | null;
  paAccounts: PaAccounts | null;
  dailyTradeVolumesAndContracts: StackedData[];
  dailyProfitLossAndBalance: BalanceStackedData[];
}
export const AccountPABarActive: FC<AccountPABarActiveProps> = ({
  payoutSelected,
  paAccounts,
  dailyProfitLossAndBalance,
  dailyTradeVolumesAndContracts,
  onClose,
}) => {
  return (
    <div className={'flex w-full flex-col items-center text-xs'}>
      <div className={'flex items-center gap-x-1 text-2xl font-medium'}>
        <p>Account PA -</p>
        <p className={'text-[#3490FF]'}>
          {payoutSelected?.leeloo_account.rithmic_account_name}
        </p>
      </div>
      <div className={'flex gap-x-6 items-center my-6'}>
        <div className={'flex items-center gap-x-1'}>
          <p>Active Trading Days:</p>
          <ControlUnit
            active
            className={'bg-[#1C402F]'}
            value={
              payoutSelected?.leeloo_account.trading_days?.toString() ?? '0'
            }
          />
        </div>
        <div className={'flex items-center gap-x-1'}>
          <p>Status:</p>
          {paAccounts?.status?.includes('closed') ? (
            <ControlUnit
              className={'bg-[#5A0000]'}
              minWidth={55}
              value={'Closed'}
            />
          ) : (
            <ControlUnit active minWidth={55} value={'Active'} />
          )}
        </div>
        <p>
          Balance: $
          {formatCurrency(
            Number(payoutSelected?.leeloo_account.account_balance),
            2
          )}
        </p>
        <p>
          {formatDate(
            payoutSelected?.leeloo_account.account_balance_date ?? ''
          )}
        </p>
      </div>
      <div className={'flex flex-col w-full gap-y-10'}>
        <DailyTradeChart
          angle={-30}
          barSize={14}
          data={dailyTradeVolumesAndContracts}
          dot={false}
          height={320}
          legendClassName={'mb-10'}
        />
        <DailyBalanceChart
          angle={-30}
          barSize={14}
          data={dailyProfitLossAndBalance}
          dot={false}
          height={320}
          legendClassName={'mb-10'}
        />
      </div>
      <div className={'flex flex-col w-full items-start mb-20 ml-20'}>
        <PayoutRanking item={paAccounts} />
        <Button size={'sm'} onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
};
